module.exports = __webpack_public_path__ + "static/media/circle-user-regular.22547296.svg";